



















import Vue from 'vue'
import Loading from '@/components/Loading.vue'
import { Configuration, ConferenceDoctorDetail, ConferenceDoctorMemberRestControllerApi } from '@/types/api-docs'
import UserDetailForm from '@/components/UserDetailForm.vue'
import destinationItems from '@/mixins/memberDestination'

export interface DataType {
  pageName: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  breadcrumbs: Array<any>
  conferenceDoctorsId: number
  user?: ConferenceDoctorDetail
  loading: boolean
  isFormValid: boolean
}

const conferenceDoctorApi = new ConferenceDoctorMemberRestControllerApi(
  new Configuration({ basePath: `${window.location.origin}` })
)

export default Vue.extend({
  mixins: [destinationItems],
  components: {
    UserDetailForm,
    Loading,
  },
  data(): DataType {
    return {
      pageName: this.$route.meta.title,
      breadcrumbs: [
        {
          text: 'HOME',
          href: '/member',
        },
        {
          text: `${this.$route.meta.title}`,
          disabled: true,
        },
      ],
      conferenceDoctorsId: Number(this.$route.params.id),
      user: undefined,
      loading: false,
      isFormValid: true,
    }
  },
  async mounted() {
    await this.fetchMember()
  },
  computed: {},
  methods: {
    async fetchMember() {
      const { data } = await conferenceDoctorApi.fetchConferenceDoctorDetail(this.conferenceDoctorsId)
      this.user = data
    },
    async updateMember() {
      if (!this.user) {
        return
      }
      if (!confirm('会員情報を更新します。よろしいですか？')) {
        return
      }

      this.loading = true
      await conferenceDoctorApi
        .updateConferenceDoctorDetail(this.user)
        .then(() => {
          alert('更新しました')
        })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((err: any) => {
          let message = '更新に失敗しました'
          const res = err.response
          const status = res === undefined ? undefined : res.status
          if (status === 409) {
            message = `このメールアドレスは登録済みのため更新できませんでした[${this.user?.mail}]`
          }
          alert(message)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
})
